import { h } from 'preact'
import { isTouchDevice, tagParser, linkParser } from '../../js/modules/utilities.js'
import { useState } from 'preact/hooks'

export const BanniereImage = ({ debug, images, alt, URL, analytics, cacheKey, legalNotice }) => {
   let deviceType = window.dataStoreHP.device
   let context = window.dataStoreHP.pageId

   images = addProxymediaParams(images, deviceType, context)
   let adviseTags = {}
   if (analytics.pdbSc === 'adv') {
      adviseTags = {
         'data-pdb-ta': analytics.pdbTa,
         'data-adv-canal': analytics.advCanal,
         'data-adv-cappingdata': analytics.advCappingdata,
      }
   }

   return (
      <div class={`position-relative context-${context}`}>
         <a
            class={`o-carousel-item small-height banniereImage  banner-${context} ${debug ? 'debug' : ''}`}
            href={URL}
            data-testid="banner"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={images.img1}
            {...adviseTags}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
            data-cache-key={cacheKey}
         >
            {deviceType === 'mobile' ? <PictureMobile images={images} alt={alt} /> : <PictureDesktop images={images} alt={alt} />}
         </a>
         {(legalNotice.content !== '' || legalNotice.title !== '') ? <LegalNotice {...legalNotice} /> : ''}
      </div>
   )
}

function LegalNotice({ showButtonLabel, title, content, background }) {
   const [legalState, setLegalState] = useState(false)
   const [legalHoverState, setLegalHoverState] = useState(false)
   // Temporaire en attendant que l'animation retire le (i) du bouton
   showButtonLabel = showButtonLabel.replace('[icon=info]', '')
   // ===============================================================

   const toggleLegals = () => {
      setLegalState(!legalState)
      if (legalState === false) {
         pauseCarrousel()
      } else {
         resetCarrousel()
      }
   }

   const showLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(true)
   }

   const hideLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(false)
   }

   const pauseCarrousel = () => {
      const isCarrouselPlaying = document.querySelector('.glide__playpause--pause') ? true : false
      if (isCarrouselPlaying) {
         document.querySelector('.glide__playpause').classList.add('pauseByLegals')
         document.querySelector('.glide__playpause').click()
      }
   }

   const resetCarrousel = () => {
      const isCarrouselPause = document.querySelector('.glide__playpause--play') ? true : false
      if (isCarrouselPause) {
         let isCarrouselPausedByLegal = document.querySelector('.glide__playpause.pauseByLegals') ? true : false
         if (isCarrouselPausedByLegal) {
            document.querySelector('.glide__playpause').click()
            document.querySelector('.glide__playpause').classList.remove('pauseByLegals')
         }
      }
   }

   return (
      <div
         class={`bannerLegalNotice ${legalState ? 'openContent' : ''} ${legalHoverState ? 'isHover' : ''} ${background === 'white' ? 'white-bg' : 'black-bg'}`}
         onMouseLeave={hideLegals}
      >
         <div id="legalNoticePanel" class="contentLegalNotice" aria-hidden={!legalState}>
            <span class="closeLegal" onClick={toggleLegals}>
               &times;
            </span>
            <div class="contentText">
               {title !== '' ? <div class="legalNoticeTitle" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></div> : null}
               {content !== '' ? <div dangerouslySetInnerHTML={{ __html: tagParser(linkParser(content)) }}></div> : null}
            </div>
         </div>
         <span
            class="showButton"
            onClick={toggleLegals}
            onMouseEnter={showLegals}
            tabindex="0"
            role="button"
            aria-expanded={legalState}
            aria-pressed={legalState}
            aria-controls="legalNoticePanel"
         >
            <span class="showButton-label">{showButtonLabel}</span>&nbsp;<span class="icon icon-info"></span>
         </span>
      </div>
   )
}

function PictureDesktop({ images, alt }) {
   return (
      <picture>
         <source srcset={images.img3} media="(max-width: 959px)" />
         <source srcset={images.img1} media="(max-width: 1199px)" />
         <img class="background-img" src={images.img2} alt={alt} />
      </picture>
   )
}

function PictureMobile({ images, alt }) {
   return (
      <picture>
         <source srcset={images.img1} media="(max-width: 479px)" />
         <source srcset={images.img2} media="(max-width: 599px)" />
         <source srcset={images.img3} media="(max-width: 719px)" />
         <img src={images.img4} alt={alt} class="background-img" />
      </picture>
   )
}

function addProxymediaParams(imagesData, deviceType, context) {
   let images, paramImg1, paramImg2, paramImg3, paramImg4
   deviceType = deviceType === 'mobile' ? 'mobile' : 'desktop'
   context = `${context}-${deviceType}`
   switch (context) {
      case '960x250':
      case 'hp-regulier-desktop':
         paramImg1 = 'format=960x250'
         paramImg2 = 'crop=960,250,right,32'
         paramImg3 = 'format=x384'
         break
      case '480x400':
      case 'hp-regulier-mobile':
      case 'hp-prospect-mobile':
      case 'hp-occasionnel-mobile':
      case 'vitrine-boutique-mobile':
      case 'vitrine-boutique-client-mobile':
         paramImg1 = 'format=480x400'
         paramImg2 = 'format=600x240'
         paramImg3 = 'format=720x300'
         paramImg4 = 'format=900x360'
         break
      case '960x380':
      case 'hp-prospect-desktop':
         paramImg1 = 'format=960x380'
         paramImg2 = 'crop=960,380,0,center'
         paramImg3 = 'format=x384'
         break
      case '1500x380':
      case 'hp-occasionnel-desktop':
      case 'n1-forfaits-desktop':
      case 'n1-forfaits-prospect-desktop':
      case 'vitrine-boutique-desktop':
      case 'vitrine-boutique-client-desktop':
         paramImg1 = 'format=x304'
         paramImg2 = 'format=x380'
         paramImg3 = 'format=x384'
         break
      case '480x520':
      case 'n1-forfaits-mobile':
      case 'n1-forfaits-prospect-mobile':
      case 'n1-tv-mobile':
      case 'n1-tv-prospect-mobile':
         paramImg1 = 'format=480x520'
         paramImg2 = 'format=600x240'
         paramImg3 = 'format=720x300'
         paramImg4 = 'format=900x360'
         break
      case '960x310':
      case 'n1-tv-desktop':
      case 'n1-tv-prospect-desktop':
         paramImg1 = 'format=960x310'
         paramImg2 = 'crop=960,310,0,39'
         paramImg3 = 'format=x384'
         break
   }

   if (deviceType === 'mobile') {
      images = {
         img1: `${imagesData.img1}?${paramImg1}&saveas=webp`,
         img2: `${imagesData.img2}?${paramImg2}&saveas=webp`,
         img3: `${imagesData.img2}?${paramImg3}&saveas=webp`,
         img4: `${imagesData.img2}?${paramImg4}&saveas=webp`,
      }
   } else {
      images = {
         img1: `${imagesData.img1}?${paramImg1}&saveas=webp`,
         img2: `${imagesData.img1}?${paramImg2}&saveas=webp`,
         img3: `${imagesData.img2}?${paramImg3}&saveas=webp`,
      }
   }

   return images
}
